import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { BUTTON_SIZE } from '../BUTTON_SIZE';

interface IButtonSizerProps extends IPropsWithChildren {
    size?: BUTTON_SIZE;
}

export function ButtonSizer (props: IButtonSizerProps): ReactElement {
    const {
        size = BUTTON_SIZE.DEFAULT,
        children,
    }: IButtonSizerProps = props;

    return (
        <div
            className={classNames({
                'py-1': size === BUTTON_SIZE.SMALL,
                'py-2': size === BUTTON_SIZE.DEFAULT,
            })}
        >
            {children}
        </div>
    );
}
